import { connect } from 'react-redux';
import Rename from './Rename';

const mapStateToProps = state => ({
  userGroup: state.userGroups.details.userGroup,
  filters: state.userGroups.list.filters,
});

export default connect(mapStateToProps, null)(Rename);
